<template>
  <el-container>
    <el-header style="text-align: left;line-height: 32px">
      <el-row>

        <el-col :xs="24" :sm="5" :md="5" style="font-size: 14px">
          查找快递单号：
        </el-col>
        <el-col :xs="24" :sm="14" :md="16">
          <el-input size="small" v-model="search" placeholder="请输入收货人手机号" clearable
                    @keyup.enter.native="searchExpress"></el-input>
          <el-button size="small" @click="searchExpress">查找</el-button>
        </el-col>
      </el-row>

    </el-header>
    <el-main>

      <el-table
        :data="tableData"
        style="width: 90%;margin-top: 20px">
        <el-table-column
          prop="expressNumber"
          label="快递单号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="createdTime"
          label="录入时间"
          width="220">
        </el-table-column>
        <el-table-column
          prop="serviceName"
          label="收货人">
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          small
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :page-size="5"
          :total="total">
        </el-pagination>
      </div>
    </el-main>
  </el-container>


</template>

<script>
  export default {
    name: "FindExpress",
    data() {
      return {
        labelPosition: 'right',
        activeIndex: '1',
        search: '',
        currentPage: 1,
        total: 0,
        loading: false,
        dialogVisible: false,
        tableData: []
      };
    },
    methods: {

      /** 搜索快递信息 */
      searchExpress() {

        this.loading = true;
        this.$http.get("https://yuanteng.tech:8081/express/get_express?servicePhone=" + this.search + "&currentPage=" + this.currentPage + "&size=5").then(res => {
          if (res.data.length == 0) {
            this.$message.warning("未查询到任何数据");
          }
          this.tableData = res.data;
        }).finally(() => {
          this.loading = false;
        });
      },

      //分页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchExpress();
        // console.log(`当前页: ${val}`);
      }
    }

  }
</script>

<style scoped>
  .el-input {
    /*width: 13vw;*/
  }

  .el-main {
    text-align: left;
  }


  .pagination {
    margin-top: 20px;
    text-align: right;
    right: 2px;
  }

  @media screen {
    /deep/ .el-form--label-top .el-form-item__label {
      padding: 0 !important;
    }
  }

  @media (max-width: 376px) {
    .el-input {
      width: 60%
    }

  }

  @media screen and (max-width: 768px) and (min-width: 376px) {
    .el-input {
      width: 50%
    }


    /deep/ .el-form-item {
      display: flex;
      justify-content: left !important;
      flex-direction: column;
    }

    /deep/ .el-form-item__label {
      text-align: left !important;
      width: 120px !important;
    }


  }

  @media screen and (max-width: 1280px) and (min-width: 768px) {
    .el-input {
      width: 16vw
    }

  }

  @media screen and (min-width: 1280px) {
    .el-input {
      width: 16vw
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/FindExpress.vue